import { createAction } from '@reduxjs/toolkit';

import { errorPayloadCreator, getPayloadCreator, type Meta } from 'app-components/flux/core/actionHelpers';
import type { BaseResource, QcsSyncResourcesPayload } from 'app-components/flux/core/resourceStoreTypes';
import type {
  FreeToSpend,
  FreeToSpendPatch,
  FreeToSpendPropsImmu,
  PlannedSpendingItem,
  PSICreatePayload,
} from 'app-components/flux/free-to-spend/freeToSpendTypes';

/**
 * `skipRefresh`: another write follows this one, and that write's success asks for the refresh.
 * `onlyRolloverOf`: the filter id of the one item whose rollover changed. The request carries only that change, and the
 * store still gets the whole plan.
 */
type UpdateFreeToSpendMeta = Meta & { skipRefresh?: boolean; onlyRolloverOf?: string };

const syncF2SPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<FreeToSpendPropsImmu>>();
const F2SPayloadCreator = getPayloadCreator<FreeToSpend>();
const PlannedSpendingPayloadCreator = getPayloadCreator<PlannedSpendingItem>();
const batchReleasePayloadCreator = getPayloadCreator<string>();

export const getFreeToSpend = createAction('GET_FREE_TO_SPEND', getPayloadCreator());
export const getFreeToSpendSuccess = createAction('GET_FREE_TO_SPEND_SUCCESS', syncF2SPayloadCreator);
export const getFreeToSpendFailure = createAction('GET_FREE_TO_SPEND_FAILURE', errorPayloadCreator);

export const updateFreeToSpend = createAction(
  'UPDATE_FREE_TO_SPEND',
  getPayloadCreator<FreeToSpend | FreeToSpendPatch, BaseResource, UpdateFreeToSpendMeta>(),
);
export const updateFreeToSpendSuccess = createAction(
  'UPDATE_FREE_TO_SPEND_SUCCESS',
  getPayloadCreator<FreeToSpend, BaseResource, UpdateFreeToSpendMeta>(),
);
export const updateFreeToSpendFailure = createAction('UPDATE_FREE_TO_SPEND_FAILURE', errorPayloadCreator);

export const updateFreeToSpendOptimistic = createAction('UPDATE_FREE_TO_SPEND_OPTIMISTIC', F2SPayloadCreator);

export const createPlannedSpending = createAction('CREATE_PLANNED_SPENDING', getPayloadCreator<PSICreatePayload>());

export const deletePlannedSpending = createAction('DELETE_PLANNED_SPENDING', PlannedSpendingPayloadCreator);

export const updateFreeToSpendsBump = createAction('UPDATE_FREE_TO_SPEND_BUMP', syncF2SPayloadCreator);
export const doBatchRelease = createAction('DO_BATCH_RELEASE', batchReleasePayloadCreator);
